import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';
import FilterTableProvider from 'shell/hooks/use-filter-table/provider';
import { FiltersFormPublishedEvents } from './list/types';

export const initialValues: FiltersFormPublishedEvents = {
  typeEventCode: '',
  dateTimePublicationFrom: null,
  dateTimePublicationTo: null,
  orders: {},
  page: 0,
  rowsPerPage: 10,
};

const PagePublishedEventsInitializer = (): ReactElement => {
  return (
    <FilterTableProvider initialValues={initialValues}>
      <Outlet />
    </FilterTableProvider>
  );
};

PagePublishedEventsInitializer.displayName = 'Page published events initializer component';

export default PagePublishedEventsInitializer;
